import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { CnpjLookup } from "@interfaces/cnpj-lookup";
import { NfCompany } from "@interfaces/company-nf";
import { ParametrizationIssuesResponse } from "@interfaces/parametrization-issue";
import { NfseCityAuth } from "@interfaces/nfse-city-auth";
import { PNCompany } from "@interfaces/pn-company";
import { catchError, of } from "rxjs";
import { HttpService } from "./http.service";
import { Store } from "@ngrx/store";
import { selectToken } from "@state/selectors/user.selectors";
import { Usage } from "@interfaces/usage";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class CompanyService {
  baseUrl = `${environment.api.mv.nf}/empresa`;
  token = this.store.selectSignal(selectToken);

  constructor(
    private readonly httpService: HttpService,
    private readonly store: Store
  ) {}

  uploadLogo(data: FormData) {
    return this.httpService.post<{
      message: string;
    }>(
      `${this.baseUrl}/logotipo`,
      data,
      new HttpHeaders({
        Authorization: `Bearer ${this.token()}`
      })
    );
  }

  public fetchNfCompany(token: string) {
    return this.httpService.get<NfCompany>(
      `${this.baseUrl}`,
      new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    );
  }

  public fetchPNCompany() {
    return this.httpService.get<PNCompany>(`${this.baseUrl}/cnpj`);
  }

  /** Como a prefeitura do município autentica a NFS-e (certificado, login, senha, token). */
  public fetchNfseCityAuth(codigoIbge: string) {
    return this.httpService.get<NfseCityAuth>(
      `${this.baseUrl}/nfse/cidade/${codigoIbge}`
    );
  }

  /**
   * Consulta o CNPJ na Receita pelo nf-server (PlugNotas GET /cnpj + /cep):
   * devolve o cadastro já no formato do formulário e os NCMs sugeridos pelos
   * CNAEs. Antes a consulta era feita direto na BrasilAPI pelo navegador.
   */
  public fetchCnpj(cnpj: string) {
    const cnpjDigits = cnpj.replace(/\D/g, "");
    return this.httpService.get<CnpjLookup>(
      `${this.baseUrl}/consulta-cnpj/${cnpjDigits}`
    );
  }

  public saveCompany(payload: PNCompany) {
    const companyPayload = {
      ...(payload as unknown as Record<string, unknown>)
    };
    delete companyPayload["userId"];
    return this.httpService.post<NfCompany>(`${this.baseUrl}`, companyPayload);
  }

  public fetchlimits() {
    return this.httpService.get<Usage>(`${this.baseUrl}/limites`);
  }

  /** Pendências de parametrização exibidas na aba "Pendências" do painel do contador. */
  public fetchParametrizationIssues() {
    return this.httpService.get<ParametrizationIssuesResponse>(
      `${this.baseUrl}/pendencias`
    );
  }

  public checkSubscriptionState() {
    return this.httpService
      .post<boolean>(
        `${environment.api.mv.zemt}/usuario/liberarGerarNota`,
        null,
        new HttpHeaders({
          Authorization: `Bearer ${this.token()}`
        })
      )
      .pipe(catchError(() => of(false)));
  }
}
